module.exports = __webpack_public_path__ + "static/media/naturalGas_avacon.bcf5ad06.svg";